const luhn = require("fast-luhn");

const regexCC_CatchAll = /\b\d(?:[\W_ ]*\d){12,18}\b/g;
const regexCC_Common16 = /\b\d(?:[\W_ ]*\d){15}\b/g;
const regexCC_AMEX = /\b\d(?:[\W_ ]*\d){14}\b/g;

function maskMatches(message, matches, length = -1, suffix = "") {
    if(!matches) return message;
        
    let maskedMessage = message;
    matches.forEach((match) => {        
        // Remove internal special characters and whitespaces so that we're left with a whole number
        const cleanedMatch = match.replace(/[\W_ ]/g, '');
        if(length < 0) {
            if(cleanedMatch.length < 13 || cleanedMatch.length > 19) return;
        } else if(cleanedMatch.length != length) return;
        
        if(luhn(cleanedMatch)) {
            // The appended suffix will prevent this masked number from getting picked up in subsequent regex runs.  It will be removed during cleanUp()
            const masked = cleanedMatch.slice(-4).padStart(cleanedMatch.length, "x") + suffix;
            maskedMessage = maskedMessage.replace(match, masked);
        } 
    
    });
    return maskedMessage;
};

// Covers most card formats out there including VISA, Mastercard, Discover, etc
function maskCommonFormat16(message) {
    return maskMatches(message, message.match(regexCC_Common16), 16, "v");
}

// While not the only card that uses 15 digits, American Express is more common
function maskCommonFormatAMEX(message) {
    return maskMatches(message, message.match(regexCC_AMEX), 15, "a");
}

// This will cover all remaining formats between 13 and 19 digits
function maskRemainingFormats(message) {
    return maskMatches(message, message.match(regexCC_CatchAll));
}

// I've added extra characters to some replacements so that they are not caught in subsequent regex runs.  This should remove those extra chars
function cleanUp(message) {
    // Clean up the common 16 cards
    let finalMessage = loopRemoveLastChar(message, message.match(/\bx{12}\d{4}v{1}\b/g));
    // Clean up the AMEX
    return loopRemoveLastChar(finalMessage, finalMessage.match(/\bx{11}\d{4}a{1}\b/g));
}

function loopRemoveLastChar(message, matches) {
    if(!matches) return message;

    let fixedMessage = message;
    matches.forEach((match) => {
        const fixed = match.slice(0, -1); 
        fixedMessage = fixedMessage.replace(match, fixed);
    });
    return fixedMessage;
}


/**
* @param {string} message the body of text being evaluated for credit card numbers
* @returns {string} the message with any detected credit card numbers masked to the last 4 digits
* @description this function analyzes the input message for potential credit card numbers using a combination
* of regex and the Luhn algorithm via the 'fast-luhn' library and replaces any detected credit card numbers 
* with a masked variation so that only the last 4 digits are readable.
* For a list of card format details, see https://en.wikipedia.org/wiki/Payment_card_number
*/
exports.maskCCNumber = function (message) {
    if(!message?.trim()) return message;

    /*
    QUESTION: Why multiple scans?
    ANSWER: The catch-all may end up pulling characters from a subsequent set of numbers that fail the luhn check.  
    For example (cc# shown is a test card number)
    """
4012888888881881
40 128 8#88@8 8881 88 1
4012-8888-8888-1881
4012_-_88-+!88..88881881
4012.8888.88881881
    """
    The "catch-all" regex would grab "4012888888881881 40" because it will check for 19 total digits first.
    To prevent this, we will scan first for the strictest card formats (most CCs are always 16 digits, AMEX is always 15 digits)
    */

    let cleanedMessage = message.trim();
    cleanedMessage = maskCommonFormat16(cleanedMessage);
    cleanedMessage = maskCommonFormatAMEX(cleanedMessage); 
    cleanedMessage = maskRemainingFormats(cleanedMessage);
    cleanedMessage = cleanUp(cleanedMessage);
    return cleanedMessage;
}
